import Vue from 'vue';
import Router from 'vue-router';
 
Vue.use(Router);
 
const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/view/homepage/index.vue'),
  },
];
const router = new Router({
  mode: 'hash',
  routes,
});
// 导出路由
export default router;